var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunburstRing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sunburstGradient",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fde68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#f59e0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ea580c"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 245,
    fill: "none",
    stroke: "url(#sunburstGradient)",
    strokeWidth: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#f59e0b",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 6,
    x2: 250,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 464,
    x2: 250,
    y2: 494
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 250,
    x2: 36,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464,
    y1: 250,
    x2: 494,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 77,
    x2: 98,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402,
    y1: 402,
    x2: 423,
    y2: 423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 423,
    x2: 98,
    y2: 402
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402,
    y1: 98,
    x2: 423,
    y2: 77
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunburstRing);
export default __webpack_public_path__ + "static/media/sunburst-ring.8f38f989990c2a66124f0db74bd5428f.svg";
export { ForwardRef as ReactComponent };